import ReceiptHiddenSection from './ReceiptHiddenSection';
import {
  KoobInputToggle,
  KoobParagraph,
  KoobSegmentedControl,
  KoobSegmentedControlItem,
  KoobTitle,
} from '@koob/ui';
import { useTranslation } from 'react-i18next';
import { TravelDiaryPriceDisplayLevelEnum } from '@koob/enums';

const LEVELS = [
  TravelDiaryPriceDisplayLevelEnum.TOTAL,
  TravelDiaryPriceDisplayLevelEnum.CATEGORY,
  TravelDiaryPriceDisplayLevelEnum.ITEMIZED,
];

export default function ReceiptTravelDiaryPriceDisplay({
  isTravelDiaryPriceDisplayed = false,
  travelDiaryPriceDisplayLevel,
  setTravelDiaryPriceDisplay,
}) {
  const { t } = useTranslation('trips');
  const selectedLevel =
    travelDiaryPriceDisplayLevel ?? TravelDiaryPriceDisplayLevelEnum.TOTAL;

  return (
    <ReceiptHiddenSection className="mt-3">
      <KoobTitle size="md">
        {t('receipt.travelDiaryPriceDisplay.title')}
      </KoobTitle>

      <KoobParagraph size="sm">
        {t('receipt.travelDiaryPriceDisplay.description')}
      </KoobParagraph>

      <div className="mt-3">
        <KoobInputToggle
          checked={isTravelDiaryPriceDisplayed}
          onCheckedChange={(checked) =>
            setTravelDiaryPriceDisplay?.({
              isTravelDiaryPriceDisplayed: checked,
              travelDiaryPriceDisplayLevel: checked
                ? (travelDiaryPriceDisplayLevel ?? selectedLevel)
                : null,
            })
          }
          label={t('receipt.travelDiaryPriceDisplay.enable')}
        />
      </div>

      {isTravelDiaryPriceDisplayed && (
        <div className="mt-3">
          <p className="text-sm font-medium text-gray-700 mb-2">
            {t('receipt.travelDiaryPriceDisplay.levelLabel')}
          </p>

          <KoobSegmentedControl
            value={selectedLevel}
            onValueChange={(level) =>
              setTravelDiaryPriceDisplay?.({
                travelDiaryPriceDisplayLevel: level,
              })
            }
          >
            {LEVELS.map((level) => (
              <KoobSegmentedControlItem key={level} value={level}>
                {t(`receipt.travelDiaryPriceDisplay.levels.${level}`)}
              </KoobSegmentedControlItem>
            ))}
          </KoobSegmentedControl>
        </div>
      )}
    </ReceiptHiddenSection>
  );
}
